<script>
import appConfig from "@/app.config";
// layout
import Layout from "../../layouts/auth";
export default {
	page: {
		title: "Configuration Failure",
		meta: [{ name: "description", content: appConfig.description }]
	},
	components: { Layout }
};
</script>
<template>
	<Layout>
		<div class="row justify-content-center align-items-center h-100">
			<div class="col-12">
				<div class="text-center">
					<h1 class="display-2 font-weight-medium">
						<i class="mdi mdi-alert text-danger"></i>
						Oops!
					</h1>
					<h4 class="text-uppercase">Configuration Failure</h4>
					<label class="col-lg-5"
						>Can't Load URL: The domain of this URL isn't included
						in the app's domains. To be able to load this URL, add
						all domains and subdomains of your app to the app
						Domains field in your app settings.</label
					>
					<!-- <div class="mt-4 text-center">
              <router-link tag="a" class="btn btn-primary" to="/">Back to Dashboard</router-link>
            </div> -->
					<div class="text-center">
						<img
							src="@/assets/images/error-img.png"
							alt
							class="img-fluid"
							style="max-width:480px;"
						/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
